import React from 'react';
import {useParams} from 'react-router-dom';
import {useSalesforceContactRecordTypesQuery} from 'api';
import useSearchParams from '../../../../useSearchParams';

const RecordType = () => {
  const {query, setQuery} = useSearchParams();
  const {poolId} = useParams<{poolId: string}>();
  const {data: {salesforceContactRecordTypes = []} = {}} =
    useSalesforceContactRecordTypesQuery({
      variables: {
        poolUuid: poolId,
      },
    });

  return (
    <div className="flex flex-col gap-2">
      <div className="text-c-base font-bold">レコードタイプ</div>
      <select
        className="form-select border-c-border rounded text-base w-full"
        onChange={(e) => {
          setQuery({
            ...query,
            salesforceContactRecordTypeId: e.target.value,
          });
        }}
        value={query?.salesforceContactRecordTypeId}>
        <option value="" />
        {salesforceContactRecordTypes.map((salesforceContactRecordType) => (
          <option
            value={salesforceContactRecordType.id}
            key={salesforceContactRecordType.id}>
            {salesforceContactRecordType.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RecordType;
